import React from 'react'; // Importamos React
import PropTypes from 'prop-types';
import './ad.video.container.css';
import AdControls from './controls/ad.controls';
import { logDebugging } from '../../log/logger';
import AdLoading from './controls/ad.loading';
import DisplayPlayerController from '../players/display/display.player.controller';

export default function VideoPlayerContainer({ config, adVideo, viewState }) {
  let result = (
    <div id={'video-ext-container'} className={`video-ext-container ${viewState || ''}`}>
      <AdLoading />
      <div className="tpx-ext-control-bar "></div>
    </div>
  );
  const cssTypeDisplay = adVideo instanceof DisplayPlayerController ? 'ext-display' : 'ext-video';
  if (adVideo) {
    logDebugging('adVideo', adVideo);
    result = (
      <div
        id={'video-ext-container'}
        className={`video-ext-container ${viewState || ''} ${cssTypeDisplay}`}
      >
        <AdLoading />
        <div className="tpx-ext-control-bar ">
          <AdControls adVideo={adVideo} config={config} />
        </div>
      </div>
    );
  }

  return result;
}

VideoPlayerContainer.propTypes = {
  config: PropTypes.object.isRequired,
  adVideo: PropTypes.object,
  viewState: PropTypes.string,
};
